var win = self, evts = {}, tid = 0;
//触发窗口大小变更事件
function triggerResize() {
    var root = document.documentElement, w = root.clientWidth, h = root.clientHeight;
    for (var i in evts) {
        var evt = evts[i];
        evt && evt(w, h);
    }
    return this;
}
//邦定事件
function onResize(onresize) {
    var id = (tid++) + "" + new Date().valueOf();
    evts[id] = onresize;
    return id;
}
//邦定事件，当宽度第一次触发大于或小于指定值时触发
function onResizeWidth(num, onresize) {
    var width, id = onResize(function (w) {
        if (width <= num && w <= num || width > num && w > num) return;
        width = w;
        onresize && onresize(w);
    });
    return id;
}
//邦定事件，当高度第一次触发大于或小于指定值时触发
function onResizeHeight(num, onresize) {
    var height, id = onResize(function (w, h) {
        if (height <= num && h <= num || height > num && h > num) return;
        height = h;
        onresize && onresize(h);
    });
    return id;
}
//取消邦定
function unResize(id) {
    if (!id) return this;
    delete evts[id];
    return this;
}
//邦定系统事件
win.onresize = triggerResize;
//重命名
var rtn = { on: onResize, onWidth: onResizeWidth, onHeight: onResizeHeight, un: unResize, trigger: triggerResize }
//返回对象
export default rtn;